import { Route } from 'vue-router';
export const tituloDaToolbarPeloNomeDaRota = (route: Route) => ({ titulo: route.name })